import { CompetenciaInput, DateInput, NumberInput, TextInput, TextLabel } from '@core/components/Inputs';
import CodigoBarrasInput from '@core/components/Inputs/CodigoBarrasInput';
import { FormControlLabel, Grid, Switch } from '@material-ui/core';
import SelectConta from 'app/components/Select/SelectConta';
import SelectFornecedor from 'app/components/Select/SelectFornecedor';
import React from 'react';
import ContasPagarAproveitamentoCredito from './ContasPagarAproveitamentoCredito';
import ContasPagarCategorias from './ContasPagarCategorias';
import FormaDePagamento from './FormaDePagamento';
import ListaDeOcorrencia from './ListaDeOcorrencia';
import SwitchFavorecidoFornecedor from './SwitchFavorecidoFornecedor';

const ORIGENS_LANCAMENTO = {
  CONTA_PAGAR: 'Conta a pagar',
  COMPRA: 'Compras',
  COMPRA_PRODUTO: 'Compras',
  COMPRA_SERVICO: 'Compras',
  CONCILIACAO: 'Conciliação bancária',
};

const APROVEITAMENTO_CREDITO_DEFAULT = {
  valorCreditoIbs: null,
  valorCreditoCbs: null,
  tipoAproveitamentoCredito: 'NAO_APROVEITA_CREDITO',
  aliquotaIbs: null,
  aliquotaCbs: null,
  percentualCredito: null,
  observacaoJustificativa: '',
  ativo: true,
};

const ContasPagarUnica = ({
  handleChange,
  handleBlur,
  values,
  errors,
  touched,
  isEdicao = false,
  origemCompra,
  origemConciliacao = false,
  empresaIbsCbs = false,
}) => {
  const repetirLancamento = isEdicao
    ? values?.recorrencia?.frequencia && values?.recorrencia?.quantidade
    : values?.recorrencia?.repetirLancamento;

  const sizes = {
    vencimento: {
      xs: 12,
      sm: isEdicao && values?.origemLancamento !== 'CONTA_PAGAR' ? 2 : 4,
      md: isEdicao && values?.origemLancamento !== 'CONTA_PAGAR' ? 2 : 4,
      lg: isEdicao && values?.origemLancamento !== 'CONTA_PAGAR' ? 2 : 4,
      xl: isEdicao && values?.origemLancamento !== 'CONTA_PAGAR' ? 2 : 4,
    },
    origem: {
      xs: 12,
      sm: isEdicao && values?.origemLancamento !== 'CONTA_PAGAR' ? 2 : 0,
      md: isEdicao && values?.origemLancamento !== 'CONTA_PAGAR' ? 2 : 0,
      lg: isEdicao && values?.origemLancamento !== 'CONTA_PAGAR' ? 2 : 0,
      xl: isEdicao && values?.origemLancamento !== 'CONTA_PAGAR' ? 2 : 0,
    },
  };

  function contaOrigemBaixada() {
    const somatorioValorPagoBaixas = values?.baixas?.reduce((acc, baixa) => acc + baixa.valorPago, 0);
    const valorLiquido = values?.valorLiquido;

    return somatorioValorPagoBaixas >= valorLiquido;
  }

  /*
  RNE-478 - Edição de conta a pagar
  Para as contas a pagar que estiverem com situação "Baixada", somente a aba “Anexar documento” deve ser exibida com possibilidade de edição. Todos os outros campos das outras abas devem ser exibidos desabilitados para edição.
  */
  const contaBaixadaOuParcial = values?.situacao === 'BAIXADA' || values?.situacao === 'PARCIALMENTE_BAIXADA';
  const contaBaixada = values?.situacao === 'BAIXADA';

  /*
  RNE-478 - Edição de conta a pagar
  Para as contas a pagar que estiverem com a situação “Parcial”, somente as abas “Anexar documento” e “Baixa da conta principal” deve ser exibida com possibilidade de edição. Todos os outros campos das outras abas devem ser exibidos desabilitados para edição. 
  */
  const contaParcial = values?.situacao === 'PARCIAL';

  /*
  RNE-114 - Edição de despesa parcialmente baixada 
  Quando a despesa estiver parcialmente baixada, o sistema deve obedecer as seguintes regras:

  - Para a conta que é uma retenção aberta (que possui conta principal baixada): Não deve permitir edição dos campos “Imposto” e “Valor” 
    e não deve ser permitido informar mais retenção. Nesse caso, como a conta principal está baixada, ela deve ser exibida com todos os 
    campos desabilitados.

  - Para a conta principal aberta (que possui retenção baixada): Não deve permitir edição de "Mês competência", "Valor" e "Categoria". 
    Nesse caso, como a conta da retenção está baixada, ela deve ser exibida com todos os campos desabilitados. Quando a conta estiver sido 
    lançada por código de barras, o campo "Código de barras" também deve ser exibido desabilitado para edição.
  */
  const contaOrigemBaixadaComSituacaoParcialmenteBaixada =
    contaOrigemBaixada() && values?.situacao === 'PARCIALMENTE_BAIXADA';

  return (
    <>
      <Grid item xs={12} sm={2} md={2}>
        <CompetenciaInput
          required
          fullWidth
          onBlur={handleBlur}
          id="competencia"
          label="Mês Competência"
          value={values.competencia}
          onChange={handleChange}
          touched={touched?.competencia}
          error={touched?.competencia && errors?.competencia}
          helperText={errors?.competencia}
          disabled={contaOrigemBaixadaComSituacaoParcialmenteBaixada ? true : contaBaixadaOuParcial || contaParcial}
          format="MM/YYYY"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6}>
        <SelectFornecedor
          handleChange={handleChange}
          autoFocus
          handleBlur={handleBlur}
          fornecedor={values?.fornecedor}
          touched={touched?.fornecedor}
          error={errors?.fornecedor}
          disabled={
            contaOrigemBaixadaComSituacaoParcialmenteBaixada ? true : origemCompra || contaBaixada || contaParcial
          }
          required
        />
      </Grid>
      <SwitchFavorecidoFornecedor
        checked={values?.favorecidoDiferenteFornecedor}
        handleChange={handleChange}
        handleBlur={handleBlur}
        disabled={contaOrigemBaixadaComSituacaoParcialmenteBaixada ? true : contaBaixada || contaParcial}
      />

      {values.favorecidoDiferenteFornecedor && (
        /*
        RNE-137 - Exibição do campo "Favorecido" : Public <<Functional>> Feature
        Created:	26/03/2020 14:12:20
        Modified:	27/03/2020 14:05:54
        Project:	
        Advanced:	
        O sistema deve exibir, inicialmente, somente o campo "Fornecedor" no lançamento da despesa. Caso o usuário marque o campo "Favorecido diferente do fornecedor", o sistema exibe o campo "Favorecido". Nesse caso, o "Favorecido" torna-se obrigatório.

        Observação: O sistema deve possibilitar a pesquisa de favorecidos nos fornecedores cadastrados.
        */
        <Grid item xs={12}>
          <SelectFornecedor
            label="Favorecido"
            idObject="favorecido"
            id="favorecido.id"
            handleChange={handleChange}
            handleBlur={handleBlur}
            fornecedor={values?.favorecido}
            touched={touched?.favorecido}
            error={errors?.favorecido}
            disabled={contaOrigemBaixadaComSituacaoParcialmenteBaixada ? true : contaBaixada || contaParcial}
          />
        </Grid>
      )}

      <ContasPagarCategorias
        exibirCalculo={false}
        values={values}
        handleChange={handleChange}
        handleBlur={handleBlur}
        touched={touched?.categorias}
        errors={errors?.categorias}
        disabled={contaOrigemBaixadaComSituacaoParcialmenteBaixada ? true : contaBaixadaOuParcial || contaParcial}
        disabledDescricao={contaOrigemBaixadaComSituacaoParcialmenteBaixada ? true : contaBaixada || contaParcial}
        origemCompra={origemCompra}
        origemConciliacao={origemConciliacao}
      />

      <Grid
        item
        xs={sizes.origem.xs}
        sm={sizes.origem.sm}
        md={sizes.origem.md}
        lg={sizes.origem.lg}
        xl={sizes.origem.xl}
      >
        <DateInput
          required
          fullWidth
          id="dataVencimento"
          label="Data do vencimento"
          value={values.dataVencimento}
          onChange={handleChange}
          onBlur={handleBlur}
          touched={touched?.dataVencimento}
          error={errors?.dataVencimento}
          helperText={errors?.dataVencimento}
          disabled={contaOrigemBaixadaComSituacaoParcialmenteBaixada ? true : contaBaixada || contaParcial}
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <SelectConta
          id="conta"
          fullWidth
          label="Conta"
          value={values?.conta}
          disabled={contaOrigemBaixadaComSituacaoParcialmenteBaixada ? true : contaBaixada || contaParcial}
          onChange={(event) => {
            handleChange(event);
            handleChange({
              target: {
                id: 'formaPagamento',
                value: undefined,
              },
            });
          }}
          onBlur={handleBlur}
          touched={errors?.conta}
          error={errors?.conta}
          required={errors?.conta}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormaDePagamento
          value={values?.formaPagamento}
          handleChange={handleChange}
          handleBlur={handleBlur}
          tipoConta={values?.conta?.tipo}
          disabled={
            contaOrigemBaixadaComSituacaoParcialmenteBaixada ? true : contaBaixada || !values?.conta || contaParcial
          }
          touched={errors?.formaPagamento}
          error={errors?.formaPagamento}
          required={errors?.formaPagamento}
        />
      </Grid>

      {isEdicao && values?.origemLancamento !== 'CONTA_PAGAR' && (
        <Grid
          item
          xs={sizes.origem.xs}
          sm={sizes.origem.sm}
          md={sizes.origem.md}
          lg={sizes.origem.lg}
          xl={sizes.origem.xl}
        >
          <TextLabel
            id="origemLancamento"
            label="Origem do lançamento"
            value={ORIGENS_LANCAMENTO[values?.origemLancamento]}
          />
        </Grid>
      )}

      <Grid item xs={12} sm={6}>
        <TextInput
          id="documentoFiscal"
          label="Documento fiscal"
          fullWidth
          value={values?.documentoFiscal}
          onChange={handleChange}
          onBlur={handleBlur}
          maxLength={30}
          disabled={
            contaOrigemBaixadaComSituacaoParcialmenteBaixada ? true : origemCompra || contaBaixada || contaParcial
          }
          // touched={emailTouched}
          // error={emailError}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <DateInput
          fullWidth
          id="dataEmissao"
          label="Data da emissão"
          value={values.dataEmissao}
          onChange={handleChange}
          disabled={
            contaOrigemBaixadaComSituacaoParcialmenteBaixada ? true : origemCompra || contaBaixada || contaParcial
          }
        />
      </Grid>

      <Grid item xs={12}>
        <CodigoBarrasInput
          id="linhaDigitavel"
          name="linhaDigitavel"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values?.linhaDigitavel}
          fullWidth
          disabled={contaOrigemBaixadaComSituacaoParcialmenteBaixada ? true : contaBaixada || contaParcial}
          variant="outlined"
          label="Código de barras"
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextInput
          id="observacao"
          name="observacao"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.observacao}
          error={errors.observacao}
          touched={touched.observacao}
          disabled={
            contaOrigemBaixadaComSituacaoParcialmenteBaixada ? true : contaBaixada || origemCompra || contaParcial
          }
          fullWidth
          multiline
          maxLength={500}
          rows={3}
          variant="outlined"
          label="Observação"
        />
      </Grid>

      {!origemConciliacao && (
        <Grid item xs={12}>
          <FormControlLabel
            label="Repetir lançamento"
            control={
              <Switch
                id="recorrencia.repetirLancamento"
                name="recorrencia.repetirLancamento"
                value={repetirLancamento}
                checked={repetirLancamento}
                color="primary"
                onChange={(event) => {
                  if (event.target.checked) {
                    handleChange({ target: { id: 'recorrencia', value: {} } });
                  } else {
                    handleChange({ target: { id: 'recorrencia', value: undefined } });
                  }
                  handleChange(event);
                }}
                onBlur={handleBlur}
                disabled={
                  contaOrigemBaixadaComSituacaoParcialmenteBaixada ? true : isEdicao || contaBaixada || contaParcial
                } // RNE-232
              />
            }
          />
        </Grid>
      )}
      {repetirLancamento && (
        <>
          <Grid item xs={12}>
            <span>{'As despesas regulares devem ser resgatadas periodicamente em Ações > Despesas regulares'}</span>
          </Grid>
          <Grid item xs={12} sm={6}>
            <ListaDeOcorrencia
              required
              id="recorrencia.frequencia"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values?.recorrencia?.frequencia}
              touched={errors?.recorrencia?.frequencia}
              error={errors?.recorrencia?.frequencia}
              disabled={
                contaOrigemBaixadaComSituacaoParcialmenteBaixada ? true : isEdicao || contaBaixada || contaParcial
              } // RNE-232
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <NumberInput
              required
              fullWidth
              label="Quantidade de ocorrências"
              id="recorrencia.quantidade"
              decimalScale={8}
              decimalSeparator=","
              allowNegative={false}
              isAllowed={(values) => {
                return !values.floatValue || values.floatValue <= 100;
              }}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values?.recorrencia?.quantidade}
              touched={errors?.recorrencia?.quantidade}
              error={errors?.recorrencia?.quantidade}
              disabled={
                contaOrigemBaixadaComSituacaoParcialmenteBaixada ? true : isEdicao || contaBaixada || contaParcial
              } // RNE-232
            />
          </Grid>
        </>
      )}

      {empresaIbsCbs && (
        <>
          <Grid item xs={12}>
            <FormControlLabel
              label="Aproveitamento de crédito IBS/CBS"
              control={
                <Switch
                  id="aproveitamentoCreditoAtivo"
                  name="aproveitamentoCreditoAtivo"
                  value={values?.aproveitamentoCreditoAtivo}
                  checked={values?.aproveitamentoCreditoAtivo}
                  color="primary"
                  onChange={(event) => {
                    if (event.target.checked) {
                      handleChange({
                        target: {
                          id: 'aproveitamentoCredito',
                          value: APROVEITAMENTO_CREDITO_DEFAULT,
                        },
                      });
                    } else {
                      handleChange({ target: { id: 'aproveitamentoCredito', value: null } });
                    }
                    handleChange(event);
                  }}
                  onBlur={handleBlur}
                  disabled={contaOrigemBaixadaComSituacaoParcialmenteBaixada ? true : contaBaixada || contaParcial}
                />
              }
            />
          </Grid>
          {values?.aproveitamentoCreditoAtivo && (
            <>
              <ContasPagarAproveitamentoCredito
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleBlur={handleBlur}
                touched={touched}
                aproveitamentoCreditoFlag={values?.aproveitamentoCreditoAtivo}
                disabled={contaOrigemBaixadaComSituacaoParcialmenteBaixada ? true : contaBaixada || contaParcial}
              />
            </>
          )}
        </>
      )}
    </>
  );
};

export default ContasPagarUnica;
